import styled from 'styled-components';
import Pill from '@minecraft.pill';
import { media } from '@minecraft.themes';
import Icon from '@minecraft.icon';

type WithIsPreview = { isPreview: boolean };

export const UserInfoBtnContainer = styled.div`
  background: ${(props): string => props.theme.colors.accent.greyBlue2};
  padding: 1rem 1rem 1rem 3rem;
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin: 0 1rem;
  ${media.sm`
    margin: 0;
    justify-content: flex-start;
  `}
`;

export const UserInfoSection = styled.div`
  background: ${(props): string => props.theme.colors.primary.white};
  padding: 1rem;
  ${media.sm`
    padding: 1rem 3rem;
  `}
`;

export const UserInfoHeading = styled.h3<WithIsPreview>`
  font-size: 1.7rem;
  line-height: 2rem;
  margin-bottom: ${(props): string => (props.isPreview ? '0' : '1.5rem')};
  ${media.sm`
    margin-bottom: 1.5rem;
  `}
`;

export const StylesSkillSubHeading = styled.h4`
  font-weight: 500;
  line-height: 1.5rem;
  margin-bottom: 0.2rem;
  font-size: 1rem;
  color: #37373c; // TODO: need to add this color in MineCraft
  width: 100%;
  border-bottom: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
`;

export const StyledPill = styled(Pill)`
  padding: 0 1rem;
  margin: 0.5rem 0.5rem 0 0;
`;
export const StyledIconPill = styled(StyledPill)`
  svg {
    fill: ${(props): string => props.theme.colors.primary.white};
    vertical-align: top;
  }
  padding-right: 0.75rem;
  cursor: pointer;
`;

export const PillsContainer = styled.div`
  padding-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
`;

export const UserInfoHeadingContainer = styled.div<WithIsPreview>`
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    border-bottom: ${(props): string =>
      props.isPreview ? `0.0625rem solid ${props.theme.colors.primary.ltGrey1}` : '0'};
    margin-bottom: ${(props): string => (props.isPreview ? '1.5rem' : '0')};
    padding-bottom: ${(props): string => (props.isPreview ? '1rem' : '0')};
    align-items: ${(props): string => (props.isPreview ? 'center' : 'flex-start')};
  }
`;

export const RowDivContainer = styled.div`
  width: 100%;
  page-break-inside: avoid;
  break-inside: avoid;
`;

export const SkillsList = styled.div`
  margin-bottom: -1.5rem;
  ${media.md`
    column-count: 2;
    column-gap: 3rem;
  `}
`;

export const CategoryName = styled.span`
  margin-left: 0.8rem;
`;

export const StyledIcon = styled(Icon)`
  width: 1.0625rem;
  visibility: visible;
  ${media.sm`
    visibility: hidden;
  `}
`;
